/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkcodeplaceholder3Inputs */

const en_profilelinkcodeplaceholder3 = /** @type {(inputs: Profilelinkcodeplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`123456`)
};

const de_profilelinkcodeplaceholder3 = /** @type {(inputs: Profilelinkcodeplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`123456`)
};

/**
* | output |
* | --- |
* | "123456" |
*
* @param {Profilelinkcodeplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkcodeplaceholder3 = /** @type {((inputs?: Profilelinkcodeplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkcodeplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkcodeplaceholder3(inputs)
	return de_profilelinkcodeplaceholder3(inputs)
});
export { profilelinkcodeplaceholder3 as "profileLinkCodePlaceholder" }